import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Boxes } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 6) return toast.error("Le mot de passe doit contenir au moins 6 caractères.");
    if (pwd !== pwd2) return toast.error("Les mots de passe ne correspondent pas.");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pwd });
      toast.success("Mot de passe réinitialisé. Connectez-vous.");
      nav("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 p-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-2xl p-6 shadow-xl">
        <div className="flex items-center gap-2 mb-6">
          <div className="h-11 w-11 rounded-xl bg-blue-700 flex items-center justify-center">
            <Boxes className="h-6 w-6 text-white" />
          </div>
          <span className="font-display font-extrabold text-xl uppercase tracking-tight">Nouveau mot de passe</span>
        </div>
        {!token && <p className="text-red-600 text-sm mb-4">Lien invalide : aucun jeton fourni.</p>}
        <div className="space-y-4">
          <div>
            <Label>Nouveau mot de passe</Label>
            <Input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} className="h-12" data-testid="reset-password-input" />
          </div>
          <div>
            <Label>Confirmer</Label>
            <Input type="password" value={pwd2} onChange={(e) => setPwd2(e.target.value)} className="h-12" data-testid="reset-password-confirm" />
          </div>
          <Button type="submit" disabled={busy || !token}
            className="w-full h-12 bg-blue-800 hover:bg-blue-900 text-white font-bold tactile" data-testid="reset-submit-button">
            {busy ? "…" : "Réinitialiser"}
          </Button>
          <button type="button" onClick={() => nav("/login")} className="w-full text-sm text-slate-500 hover:underline">
            Retour à la connexion
          </button>
        </div>
      </form>
    </div>
  );
}
